import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { IAlertData } from './alert-data.interface';
import { PSnackbarComponent } from './p-snackbar.component';

@Injectable({
    providedIn: 'root'
})
export class ToasterOpenerService {
    constructor(private snackbar: MatSnackBar) {}

    open(data: IAlertData, customClasses?: string): void {
        const panelClass = ['p-alert', `p-alert-${data.type}`, `p-alert-height`];
        if (customClasses) {
            panelClass.push(customClasses);
        }
        this.snackbar.openFromComponent(PSnackbarComponent, {
            duration: data.duration || 7000,
            panelClass,
            verticalPosition: 'top',
            data
        });
    }
}
